import Overlay from 'Components/Overlay';
import React from 'react';
import Input from 'Components/Input';
import Cx from 'classnames';
import { Table } from "reactstrap";
import Moment from 'moment';

const PRDetailsPopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter prdetails">
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {props.text || ''} 
            </div>
            <section className="overflowAuto status-table-height bg-white pv-10 ph-10 wt-900">
                <div className='mt-5 mb-5 fLeft fs-16 fBold'>Price Revision Details</div>
              <Table striped className="upload-rfq-table col-1 fs-14 mb-30 br-5" responsive bordered>
                <thead>
                    <tr>
                        {!props.isTransporter && <>
                        <th className='upload-td-th upload-th' rowSpan={2}>Lane</th>
                        <th className='upload-td-th upload-th' rowSpan={2}>Transporter</th>
                        </>}
                        <th className='upload-td-th upload-th' rowSpan={2}>Base Price</th>
                        <th className='upload-td-th upload-th' rowSpan={2}>PR%</th>
                        <th className='upload-td-th upload-th' rowSpan={2}>PR Amount</th>
                        <th className='upload-td-th upload-th' rowSpan={2}>Revised Price</th>
                        <th className='upload-td-th upload-th' colSpan={2}>PR Validity</th>
                    </tr>
                    <tr>
                        <th className='upload-td-th upload-th'>From</th>
                        <th className='upload-td-th upload-th'> To</th>
                    </tr>
                </thead>
                <tbody>
                   {(props.data || []).map((prData, index) =>{
                    const bgColor = (index % 2 === 1) ? '#EFF2FD' : 'white';
                    return (<tr>
                         {!props.isTransporter && <>
                            <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>
                                <div>{prData.from} - {prData.to}</div>
                                {(prData.from_range || prData.to_range) && <div>Slab (Km): {prData.from_range} - {prData.to_range}</div>}
                            </td>
                            <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.transporter_name}</td>
                        </>}
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.base_price}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.dph_percentage && prData.dph_percentage.toFixed(1)}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.dph_amount}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.revised_price}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.dph_from_date && Moment(prData.dph_from_date).format('DD MMM YYYY') || ''}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{prData.dph_to_date && Moment(prData.dph_to_date).format('DD MMM YYYY') || ''}</td>
                    </tr>)})}
                </tbody>
            </Table>
            </section>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                {!props.isTransporter && <button className={"ht-40 br-5 white-color bg-theme fs-18 fBold wt-150"} onClick={props.onDownloadPRDetails}>Download</button>}
            </div>
        </div>
    </Overlay>
);

export default PRDetailsPopup;